import { EventName } from 'types';
import defer from 'lodash/defer';
import { preventBackspace } from 'helpers/events';
import { ESC, SPACE, ENTER } from 'constants/keys';
import { EventEntry } from './index';

export const BASE_EVENT_HANDLERS: EventEntry[] = [
  {
    event: 'orientationchange',
    handler: (emit) => window.setTimeout(() => emit('RESIZE'), 350),
  },
  {
    event: 'beforeunload',
    handler: 'UNLOAD',
  },
  {
    event: 'pagehide',
    handler: 'UNLOAD',
  },
  {
    event: 'blur',
    handler: (emit) => defer(() => {
      // if focused on encyclopedia then do not trigger
      if (document.activeElement && document.activeElement.tagName === 'IFRAME') return;

      emit('BLUR');
    }),
  },
  {
    event: 'focus',
    handler: 'FOCUS',
  },
  {
    event: 'online',
    handler: 'ONLINE',
  },
  {
    event: 'offline',
    handler: 'OFFLINE',
  },
  {
    event: 'popstate',
    handler: 'BACK_BUTTON',
  },
  {
    parent: 'document',
    event: 'visibilitychange',
    handler: (emit) => {
      let event: EventName = 'VISIBILITY_HIDDEN';
      if (document.visibilityState === 'visible') {
        event = 'VISIBILITY_VISIBLE';
      }

      emit(event);
    },
  },
  {
    parent: 'document',
    event: 'keydown',
    handler: (emit, e: Event) => {
      const event = e as KeyboardEvent;
      preventBackspace(event);
      const { keyCode } = event;
      emit('KEY_DOWN', event);
      if (keyCode === ENTER) {
        emit('KEY_ENTER', event);
        return;
      }

      if (keyCode === ESC) {
        emit('KEY_ESC', event);
        return;
      }

      if (keyCode === SPACE) {
        emit('KEY_SPACE', event);
      }
    },
  },
];
